var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ad)?_c('div',{staticClass:"floor-ad"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.ad.adv_code),expression:"ad.adv_code"}],on:{"click":function($event){return _vm.goAdUrl(_vm.ad)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }